function nwgGetWishlist() {
  try {
    const raw = JSON.parse(localStorage.getItem("nwg_wishlist")) || [];
    const normalized = raw
      .map((item) => {
        if (!item) return null;

        if (typeof item === "object" && item.id) {
          return {
            id: String(item.id),
            title: item.title || "",
            url: item.url || "",
            image: item.image || "",
            price: typeof item.price === "number" ? item.price : Number(item.price || 0),
            compareAtPrice:
              typeof item.compareAtPrice === "number"
                ? item.compareAtPrice
                : Number(item.compareAtPrice || 0),
           lang: item.lang || ""
          };
        }

        return null;
      })
      .filter(Boolean);

    const unique = [...new Map(normalized.map((item) => [item.id, item])).values()];
    return unique;
  } catch (e) {
    return [];
  }
}

function nwgSaveWishlist(list) {
  const unique = [...new Map((list || []).filter(Boolean).map((item) => [String(item.id), item])).values()];
  localStorage.setItem("nwg_wishlist", JSON.stringify(unique));
  document.dispatchEvent(
    new CustomEvent("nwg:wishlist:updated", {
      detail: { count: unique.length }
    })
  );
}

function nwgShowToast(type) {
  const lang = (document.documentElement.lang || "").toLowerCase();
  const isGerman = lang.includes("de");

  let message = "";
  if (type === "added") message = isGerman ? "Zu Favoriten hinzugefügt" : "Saved to favorites";
  if (type === "removed") message = isGerman ? "Aus Favoriten entfernt" : "Removed from favorites";
  if (!message) return;

  let toast = document.querySelector(".nwg-wishlist-toast");
  if (!toast) {
    toast = document.createElement("div");
    toast.className = "nwg-wishlist-toast";
    document.body.appendChild(toast);
  }

  toast.textContent = message;
  toast.classList.remove("is-visible");

  requestAnimationFrame(() => {
    toast.classList.add("is-visible");
  });

  clearTimeout(window.nwgWishlistToastTimeout);
  window.nwgWishlistToastTimeout = setTimeout(() => {
    toast.classList.remove("is-visible");
  }, 1800);
}

function nwgAnimateHeartToHeader(sourceButton) {
  const headerTarget = document.querySelector(".nwg-wishlist-header-link");
  if (!sourceButton || !headerTarget) return;

  const sourceRect = sourceButton.getBoundingClientRect();
  const targetRect = headerTarget.getBoundingClientRect();

  const flyingHeart = document.createElement("div");
  flyingHeart.className = "nwg-flying-heart";
  flyingHeart.innerHTML = `
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 C2 6 4 4 6.5 4 C8.04 4 9.54 4.81 10.4 6.09 C11.26 4.81 12.76 4 14.3 4 C16.8 4 18.8 6 18.8 8.5 C18.8 12.28 15.4 15.36 10.25 20.04 L12 21.35z"/>
    </svg>
  `;

  document.body.appendChild(flyingHeart);

  const startX = sourceRect.left + sourceRect.width / 2;
  const startY = sourceRect.top + sourceRect.height / 2;
  const endX = targetRect.left + targetRect.width / 2;
  const endY = targetRect.top + targetRect.height / 2;

  flyingHeart.style.left = `${startX}px`;
  flyingHeart.style.top = `${startY}px`;
  flyingHeart.style.setProperty("--nwg-fly-x", `${endX - startX}px`);
  flyingHeart.style.setProperty("--nwg-fly-y", `${endY - startY}px`);

  requestAnimationFrame(() => {
    flyingHeart.classList.add("is-animating");
  });

  flyingHeart.addEventListener(
    "animationend",
    () => {
      flyingHeart.remove();
      headerTarget.classList.add("nwg-wishlist-header-pulse");
      setTimeout(() => {
        headerTarget.classList.remove("nwg-wishlist-header-pulse");
      }, 350);
    },
    { once: true }
  );
}

function nwgToggleWishlist(button) {
  const id = String(button.getAttribute("data-nwg-wishlist-id"));
  const title = button.getAttribute("data-nwg-wishlist-title") || "";
  const url = button.getAttribute("data-nwg-wishlist-url") || "";
  const image = button.getAttribute("data-nwg-wishlist-image") || "";
  const price = Number(button.getAttribute("data-nwg-wishlist-price") || 0);
  const compareAtPrice = Number(button.getAttribute("data-nwg-wishlist-compare-at-price") || 0);
  const lang = (document.documentElement.lang || "").toLowerCase();

  let list = nwgGetWishlist();
  const exists = list.some((item) => String(item.id) === id);

  if (exists) {
    list = list.filter((item) => String(item.id) !== id);
    nwgSaveWishlist(list);
    nwgUpdateWishlistButtons();
    nwgShowToast("removed");
  } else {
    list.push({ id, title, url, image, price, compareAtPrice, lang });
    nwgSaveWishlist(list);
    nwgUpdateWishlistButtons();
    nwgAnimateHeartToHeader(button);
    nwgShowToast("added");
  }
}

function nwgUpdateWishlistButtons() {
  const list = nwgGetWishlist();
  const savedIds = list.map((item) => String(item.id));

  document.querySelectorAll("[data-nwg-wishlist-id]").forEach((button) => {
    const id = String(button.getAttribute("data-nwg-wishlist-id"));
    const label = button.querySelector(".nwg-wishlist-label");
    const defaultLabel = button.getAttribute("data-label-default") || "Save to favorites";
    const savedLabel = button.getAttribute("data-label-saved") || "Saved to favorites";

    if (savedIds.includes(id)) {
      button.classList.add("is-active");
      button.setAttribute("aria-pressed", "true");
      button.setAttribute("aria-label", savedLabel);
      if (label) label.textContent = savedLabel;
    } else {
      button.classList.remove("is-active");
      button.setAttribute("aria-pressed", "false");
      button.setAttribute("aria-label", defaultLabel);
      if (label) label.textContent = defaultLabel;
    }
  });
}

function nwgInitWishlistUi() {
  nwgUpdateWishlistButtons();
}

document.addEventListener("DOMContentLoaded", nwgInitWishlistUi);
window.addEventListener("load", nwgInitWishlistUi);
document.addEventListener("shopify:section:load", nwgInitWishlistUi);
document.addEventListener("shopify:section:reorder", nwgInitWishlistUi);
document.addEventListener("shopify:section:select", nwgInitWishlistUi);
document.addEventListener("nwg:wishlist:updated", nwgInitWishlistUi);

setTimeout(nwgInitWishlistUi, 300);
setTimeout(nwgInitWishlistUi, 1000);